<template>
    <div class="home">


        <button @click="init">初始化</button>
        <input v-model="msg"/>
        <button @click="sendMsg">发消息</button>
        <button @click="close">关闭</button>
    </div>
</template>

<script>

//这个就是引入刚刚封装的websocket
import {useWebSocket} from "../utils/websocket";

export default {
    name: 'Home',
    components: {

    },
    created() {

    },
    methods: {
        init(){
            this.ws = useWebSocket(this.handleMessage);
        },
        handleMessage(evt) {
            if (evt.data) {
                console.log("获取到的数据为:"+evt.data)
            }
        },
        sendMsg(){
            console.log(this.msg)
            this.ws.send(this.msg)
        },
        close(){
            this.ws.close();
        }
    },
    data() {
        return {
            ws:'',
            msg:""
        }
    },

}
</script>
